import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

/**
 * Generic content-area skeleton: a page header + stat cards + a list/table.
 * Rendered while a lazy PAGE chunk loads inside the dashboard layout, so the
 * real sidebar/header stay put and only the content area shows placeholders.
 * Shape is intentionally generic — it fits the great majority of ERP pages
 * (header + optional KPIs + a table/list). aria-busy announces the loading.
 */
export default function PageContentSkeleton() {
  return (
    <div className="space-y-6" role="status" aria-busy="true" aria-label="Yuklanmoqda">
      {/* Title row */}
      <div className="flex items-center justify-between gap-4">
        <div className="space-y-2">
          <Skeleton className="h-7 w-52" />
          <Skeleton className="h-4 w-36" />
        </div>
        <Skeleton className="h-9 w-32 rounded-xl" />
      </div>

      {/* KPI cards */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="rounded-2xl border border-hairline bg-panel p-5">
            <Skeleton className="mb-3 h-4 w-24" />
            <Skeleton className="h-8 w-32" />
          </div>
        ))}
      </div>

      {/* Table / list */}
      <div className="space-y-3 rounded-2xl border border-hairline bg-panel p-5">
        <Skeleton className="mb-2 h-5 w-40" />
        {Array.from({ length: 7 }).map((_, i) => (
          <div key={i} className="flex items-center gap-4">
            <Skeleton className="h-10 w-10 rounded-lg" />
            <Skeleton className="h-4 flex-1" />
            <Skeleton className={cn("h-4", i % 2 ? "w-28" : "w-20")} />
            <Skeleton className="h-4 w-16" />
          </div>
        ))}
      </div>
      <span className="sr-only">Yuklanmoqda…</span>
    </div>
  );
}
